import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';

import SearchResults from './SearchResults';

export default function SearchContent({ defaultContent, focusIndex, onKeyDown, onSetFocused, search }) {
  const previousSearch = useRef(search);
  useEffect(
    () => {
      if (!search.isLoading) {
        previousSearch.current = search;
      }
    },
    [search]
  );

  if (search.isLoading ? previousSearch.current.searchTerm === '' : !search.searchTerm) {
    return defaultContent;
  }

  return (
    <SearchResults
      focusIndex={focusIndex}
      onKeyDown={onKeyDown}
      onSetFocused={onSetFocused}
      search={search}
      tabIndex="0"
      role="button"
    />
  );
}

SearchContent.propTypes = {
  defaultContent: PropTypes.node,
  focusIndex: PropTypes.number,
  handleKeyDown: PropTypes.func,
  onSetFocused: PropTypes.func.isRequired,
  search: PropTypes.shape({
    isLoading: PropTypes.bool,
    results: PropTypes.array,
    searchTerm: PropTypes.string,
    timestamp: PropTypes.string,
  }),
};
